module.exports = __webpack_public_path__ + "img/GW.c619c53d.gif";